import { Col, View } from "@amzn/stencil-react-components/layout";
import { Text } from "@amzn/stencil-react-components/text";
import React, { FC, Fragment } from "react";
import { NEUTRAL_BORDER_COLOR } from "@/common/styles/design-tokens.constants";

export interface SummaryRow {
  label: string;
  value: string;
  /** Renders the value bold, as the design does for the headline facts. */
  isEmphasised?: boolean;
  /** Draws a divider above this row, grouping the rows into sections. */
  hasDividerAbove?: boolean;
}

interface SummaryRowsProps {
  rows: SummaryRow[];
  dataTestId?: string;
}

/**
 * Stacked label-over-value rows with section dividers, used by the order summary
 * on the replacement confirmation and track order screens.
 */
export const SummaryRows: FC<SummaryRowsProps> = ({ rows, dataTestId }) => (
  <Col gridGap="S200" width="100%" data-testid={dataTestId}>
    {rows.map((row) => (
      <Fragment key={row.label}>
        {row.hasDividerAbove && (
          <View
            width="100%"
            height="1px"
            style={{ backgroundColor: NEUTRAL_BORDER_COLOR }}
          />
        )}
        <Col gridGap="S100" width="100%">
          <Text fontSize="T100" color="neutral70">
            {row.label}
          </Text>
          <Text fontSize="T100" color="neutral90" fontWeight={row.isEmphasised ? "bold" : "normal"}>
            {row.value}
          </Text>
        </Col>
      </Fragment>
    ))}
  </Col>
);
